export default __webpack_public_path__ + "static/media/kanban-card.3eef6ecd.svg";